import './footer-c.scss';
import { execOnLoad } from '@general/helpers';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initFooter = (context) => {
  const footerContainer = context.classList.contains('.mobile-menu__container')
    ? context
    : context.closest('.footer-c__container');
  if (!footerContainer) return;

  const newsletterTrigger = footerContainer.querySelector(
    '.footer-c__newsletter-input',
  );
  if (newsletterTrigger) {
    const newsletterFormId =
      newsletterTrigger.getAttribute('data-newsletter-id');
    if (newsletterFormId) {
      newsletterTrigger.addEventListener('click', () => {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', newsletterFormId]);
      });
    }
  }
};

execOnLoad(window.dAgency.initFooter, '.footer-c__container');
